export default "__VITE_ASSET__da712ddf__"